import styled from "styled-components";
import { useTranslation } from "react-i18next";
import colors from "@styling/colors";
import { spacing, borderRadius } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const MetadataContainer = styled.div`
  margin-bottom: ${spacing.x3}px;
  padding: ${spacing.x2}px;
  background-color: ${colors.backgroundLight};
  border-radius: ${borderRadius.regular}px;
`;

const MetadataGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${spacing.x2}px;
`;

const MetadataItem = styled.div``;

const MetadataLabel = styled.div`
  font-size: ${fontSizes.small}px;
  color: ${colors.textMuted};
`;

const MetadataValue = styled.div<{ $color?: string }>`
  font-weight: 600;
  color: ${({ $color }) => $color || colors.text};
`;

interface DryRunMetadataProps {
  totalRows: number;
  validRows: number;
  errorCount: number;
  success: boolean;
}

export const DryRunMetadata = ({
  totalRows,
  validRows,
  errorCount,
  success,
}: DryRunMetadataProps) => {
  const { t } = useTranslation();

  return (
    <MetadataContainer>
      <MetadataGrid>
        <MetadataItem>
          <MetadataLabel>{t("productImport.metaTotalRows")}</MetadataLabel>
          <MetadataValue>{totalRows}</MetadataValue>
        </MetadataItem>
        <MetadataItem>
          <MetadataLabel>{t("productImport.metaValidRows")}</MetadataLabel>
          <MetadataValue $color={colors.success}>{validRows}</MetadataValue>
        </MetadataItem>
        <MetadataItem>
          <MetadataLabel>{t("productImport.metaErrors")}</MetadataLabel>
          <MetadataValue $color={errorCount > 0 ? colors.danger : colors.text}>
            {errorCount}
          </MetadataValue>
        </MetadataItem>
        <MetadataItem>
          <MetadataLabel>{t("productImport.metaStatus")}</MetadataLabel>
          <MetadataValue $color={success ? colors.success : colors.danger}>
            {success ? t("productImport.metaSuccess") : t("productImport.metaFailed")}
          </MetadataValue>
        </MetadataItem>
      </MetadataGrid>
    </MetadataContainer>
  );
};
